import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { HttpErrorHandler, HandleError } from '../../http-error-handler.service';
import { catchError, map } from 'rxjs/operators';
import { EndpointLocationProviderService } from './endpoint-location-provider.service';

@Injectable()
export class UserPreferenceService {

    private env = environment;
    private handleError: HandleError;

    constructor(
        private http: HttpClient,
        httpErrorHandler: HttpErrorHandler,
        private endpointLocationService: EndpointLocationProviderService
    ) {
        this.handleError = httpErrorHandler.createHandleError('UserPreferenceService');
    }

    public manageUserPreference(userPreference: any): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_AUTENTICACAO_PREFERENCE)}/ManageUserPreference`, userPreference)
            .pipe(
                catchError(this.handleError('Enviar preferências do usuário.', []))
            );
    }

    public getUserPreference(): Observable<any> {
        if(!localStorage.getItem("userPreference")) {
            return this.http.get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_AUTENTICACAO_PREFERENCE)}/GetUserPreference`)
                .pipe(
                    map(x => {
                        localStorage.setItem("userPreference", JSON.stringify(x));
                        return of(x);
                    }),
                    catchError(this.handleError('Buscar preferências do usuário.', []))
                );
        }
        else {
            return of(JSON.parse(localStorage.getItem("userPreference")));
        }
    }
}
